<template>
    <span  class="description shipment-date">
        {{date}}
    </span>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "ShipmentList_completed_date",
    props: {
        shipmentId: Number,
        packageId: Number,
    },
    computed: {
        ...mapGetters([
            "getShipments",
            "getDateFormat",
            "getTimeFormat",
            "getShipmentsPackagesById",
        ]),
        shipment() {
            return this.getShipments?.find(s => s.id == this.shipmentId);
        },
        shipmentPackage() {
            return this.getShipmentsPackagesById[this.packageId]
        },
        date() {
            return this.packageId ? this.shipmentPackage?.completed__time?.formated?.datetime : this.shipment?.completed__time?.formated?.datetime
        }
    }
}
</script>

<style scoped lang="scss">
.shipment-date {
    @include font(10px, normal, 700, none, normal, var(--shipment-date));
    white-space: nowrap;
}
</style>